module.exports = __webpack_public_path__ + "img/big_11B21_yellow.cc1c3006.png";